// extracted by mini-css-extract-plugin
export default {"editRoleSection":"style_editRoleSection__+7bQd","actionsSection":"style_actionsSection__0+eBL","formSection":"style_formSection__kJyIy"};